import { createSelector } from 'reselect';

const clientContextualMenuSelector = state => state.ClientContextualMenu;

export const isSharingSettingsModalOpenSelector = createSelector(
  clientContextualMenuSelector,
  ({ isSharingSettingsModalOpen }) => isSharingSettingsModalOpen,
);

export const modalErrorsSelector = createSelector(
  clientContextualMenuSelector,
  ({ modalErrors }) => modalErrors,
);

export const selectIsOnlineGlia = createSelector(
  clientContextualMenuSelector,
  ({ isOnlineGlia }) => isOnlineGlia,
);
